export interface TsAppVersion {
    version: string;
    name: string;
    description?: string;
    versionLong?: string;
    versionDate: string;
    gitCommitHash?: string;
    gitCommitDate?: string;
    gitTag?: string;
};

export const versions: TsAppVersion = {
    version: '1.4.6',
    name: 'fpar2-clinic-locator-ui',
    versionDate: '2026-10-30T15:46:19.448Z',
};
export default versions;
